import React from 'react';
import SearchBoxWrapper from './search-box-wrapper';

export const NoListingsSearch = ({
    boardCheckIn,
    boardCheckOut,
    adultsCount = 2,
    childrenCount = 0,
    petIncluded = false,
    boardId,
    isMobile,
    locale,
    role,
    siteName,
    edapSearchType
}) => (
    <div className="trip-board-details__empty-search">
        <SearchBoxWrapper
            boardId={boardId}
            arrival={boardCheckIn}
            departure={boardCheckOut}
            edapActionLocation={edapSearchType}
            guests={{adultsCount, childrenCount, petIncluded}}
            isMobile={isMobile}
            locale={locale}
            role={role}
            siteName={siteName}
            searchTextTitle={'tripboards.details.empty.search.title'}
            searchTextDesktop={'tripboards.details.empty.search.desktop'}
            searchTextMobile={'tripboards.details.empty.search.mobile'}
        />
    </div>
);

NoListingsSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null
};

export default NoListingsSearch;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/no-listings-search.js